var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { alias, not } from '@ember/object/computed';
import { isNone } from '@ember/utils';
import EmberObject, { computed, notifyPropertyChange, set } from '@ember/object';
let ItemSubunitAssociation = (_dec = alias('item'), _dec2 = alias('enabled'), _dec3 = not('isEnabled'), _dec4 = alias('item.name'), _dec5 = alias('subunit.token'), _dec6 = computed('subunit.token', 'item.subunits.@each.token'), _dec7 = computed('item', 'unitToken'), _class = class ItemSubunitAssociation extends EmberObject {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "content", _descriptor, this);
    _initializerDefineProperty(this, "isEnabled", _descriptor2, this);
    _initializerDefineProperty(this, "isEnabledOrder", _descriptor3, this);
    // sorts enabled before disabled
    _initializerDefineProperty(this, "name", _descriptor4, this);
    _initializerDefineProperty(this, "unitToken", _descriptor5, this);
  }
  get enabled() {
    const item = this.item;
    const subunitToken = this.subunit?.token;
    return item.enabledForUnit(subunitToken);
  }
  set enabled(value) {
    const item = this.item;
    const subunit = this.subunit;
    const subunitToken = subunit.get('token');
    if (value) {
      item.addMerchantSubunit(subunit);
      if (!isNone(item.addAffectedRelatedObjects)) {
        item.addAffectedRelatedObjects(subunitToken);
      }
    } else {
      if (!isNone(item.removeAffectedRelatedObjects)) {
        item.removeAffectedRelatedObjects(subunitToken);
      }
      item.removeMerchantSubunit(subunitToken);
    }
  }
  save() {
    return this.item.save();
  }
  set ordinal(val) {
    const unitToken = this.unitToken;
    this.item.setUnitOverride(unitToken, 'ordinal', val);
    set(this, 'item.isDirty', true);
    notifyPropertyChange(this, 'ordinal');
  }
  get ordinal() {
    return this.item.getUnitAttribute(this.unitToken, 'ordinal');
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "content", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isEnabled", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "isEnabledOrder", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "name", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "unitToken", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "enabled", [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, "enabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "ordinal", [_dec7], Object.getOwnPropertyDescriptor(_class.prototype, "ordinal"), _class.prototype), _class);
export { ItemSubunitAssociation as default };